// src/components/ui/Popover.jsx
import React from 'react';

// Accept 'reasons' array prop instead of 'content' string
function Popover({ reasons, position, onClose, popoverRef }) {

  const style = {
    position: 'absolute',
    left: `${position.x}px`,
    top: `${position.y}px`,
    zIndex: 100,
  };

  // Function to get text color class based on severity
  const getSeverityClass = (severity) => {
    if (severity === 'red') {
      return 'text-red-700'; // Red for errors/cannot
    } else if (severity === 'orange') {
      return 'text-orange-700'; // Orange for warnings/prefer_away
    }
    return 'text-gray-700'; // Default for unknown severity
  };

  return (
    <div
      ref={popoverRef}
      style={style}
      className="bg-gray-800 text-white text-xs rounded shadow-lg p-2 max-w-xs border border-gray-600"
    >
      {/* Check if reasons is an array and has items */}
      {Array.isArray(reasons) && reasons.length > 0 ? (
        <ul className="list-disc pl-4 space-y-1"> {/* Use Tailwind for list styling */}
          {reasons.map((reasonObj, index) => (
            <li key={index} className={getSeverityClass(reasonObj.severity)}>
              {reasonObj.reason}
            </li>
          ))}
        </ul>
      ) : (
        // Fallback if reasons is empty or not an array (optional)
        <span>No specific reason provided.</span>
      )}
      {/* Optional close button */}
      {/* <button onClick={onClose} ... >&times;</button> */}
    </div>
  );
}

export default Popover;